<template>
  <div class="index">
    <div class="leftbar">
      <div class="homename">{{msg}}</div>
      <div class="barbox">
        <el-collapse accordion>
          <el-collapse-item title="设备管理" name="0">
            <div
              class="bar"
              v-for="(item,index) in tabdata"
              @click="tabfun1001(index,item)"
              :key="index"
            >{{item.type1}}</div>
          </el-collapse-item>
          <!--/el-collapse>

			<el-collapse>
				<el-collapse-item title="播控设备" name="1" >
				<div class="bar" v-for="(item,index) in tabdata1" @click="tabfun5(index,item)">{{item.type1}}</div>
          </el-collapse-item-->
          <el-collapse-item  title="媒体管理" name="3">
            <div
              class="bar"
              v-for="(item,index) in tabdata3"
              @click="tabfun7(index,item)"
              :key="index"
            >{{item.type1}}</div>
          </el-collapse-item>

          <el-collapse-item  title="定时播报" name="2">
            <div
              class="bar"
              v-for="(item,index) in tabdata5"
              @click="tabfun4(index,item)"
              :key="index"
            >{{item.type1}}</div>
          </el-collapse-item>

          <el-collapse-item   title="报警系统" name="6">
            <div
              class="bar"
              v-for="(item,index) in tabdata6"
              @click="tabfun6(index,item)"
              :key="index"
            >{{item.type1}}</div>
          </el-collapse-item>

          <el-collapse-item   title="账户管理" name="4">
            <div
              class="bar"
              v-for="(item,index) in tabdata4"
              @click="tabfun100(index,item)"
              :key="index"
            >{{item.type1}}</div>
          </el-collapse-item>
          <el-collapse-item   v-if="isGM" title="账户信息" name="5">
            <div
              class="bar"
              v-for="(item,index) in tabdata10"
              @click="tabfun101(index,item)"
              :key="index"
            >{{item.type1}}</div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>

    <div class="rightbar">
      <HeaderBar></HeaderBar>
      <div class="tab">
        首页 /
        <em>{{tabtype}} / {{tabtype1}}</em>
      </div>
      <Tabnum3 ref="tabnum3" v-show="tabnum == 600"></Tabnum3>
      <Tabnum4 ref="tabnum4" v-show="tabnum == 700"></Tabnum4>
      <Tabnum5 v-show="tabnum == 500"></Tabnum5>
      <Tabnum6 v-show="tabnum  == 6"></Tabnum6>
      <Tabnum8 v-show="tabnum  == 101"></Tabnum8>
      <Tabnum9 ref="tabnum9" v-show="tabnum  == 100"></Tabnum9>
      <Tabnum10 v-show="tabnum == 300"></Tabnum10>
      <Tabnum11 v-show="tabnum == 200"></Tabnum11>
      <Tabnum12 ref="tabnum12" v-show="tabnum == 701"></Tabnum12>
      <Tabnum13 v-show="tabnum == 702"></Tabnum13>
      <Tabnum14 v-show="tabnum == 301"></Tabnum14>
      <Tabnum15 ref="tabnum15" v-show="tabnum == 601"></Tabnum15>
      <Tabnum16 ref="tabnum16" v-show="tabnum == 302"></Tabnum16>
    </div>
  </div>
</template>

<script>
import HeaderBar from "./Headerll.vue";
import Tabnum3 from "./warningset.vue";
import Tabnum4 from "./uploadfile.vue";
import Tabnum5 from "./task_list.vue";
import Tabnum6 from "./tigertask.vue";
import Tabnum7 from "./nodemg.vue";
import Tabnum8 from "./device_Mg.vue";
import Tabnum9 from "./Group_mg.vue";
import Tabnum10 from "./erjizhanghu.vue";
import Tabnum11 from "./xiugaimima.vue";
import Tabnum12 from "./wenzizhuanyuyin.vue";
import Tabnum13 from "./diantai.vue";
import Tabnum14 from "./erjizhanghu2.vue";
import Tabnum15 from "./warmingauto.vue";
import Tabnum16 from "./gis_Mg.vue";
export default {
  data() {
    return {
      msg: "极速精简板广播系统",
      nickname: "gsdfdfhdfg",
      tabtype: "媒资管理",
      tabnum: 999,
      isroot: false,
      isGM:false,
      tabtype1: "文件列表",
      tableData: [],
      tabdata: [
        {
          type: "设备管理",
          type1: "分组管理"
        },
        {
          type: "设备管理",
          type1: "设备列表"
        }
      ],
      tabdata1: [
        {
          type: "播控设备",
          type1: "设备管理"
        }
      ],
      tabdata2: [
        {
          type: "账户管理",
          type1: "子账户管理"
        }
      ],
      tabdata3: [
        {
          type: "媒体管理",
          type1: "文件管理"
        },
        {
          type: "媒体管理",
          type1: "文字转语音"
        }
      ],
      tabdata6: [
        {
          type: "报警系统",
          type1: "联动报警设置"
        },
        {
          type: "报警系统",
          type1: "自动报警设置"
        }
      ],
      tabdata4: [
        {
          type: "账户信息",
          type1: "用户信息"
        }
      ],
      tabdata10: [
        {
          type: "账户信息",
          type1: "二级账户"
        }
        /*
        ,
        {
          type: "账户信息",
          type1: "账户日志"
        },
        {
          type: "账户信息",
          type1: "视频绑定"
        }  */
      ],
      tabdata5: [
        {
          type: "定时播报",
          type1: "定时任务"
        }
      ]
    };
  },
  created() {
    if (sessionStorage.getItem("master_id") == -1) {
      this.isroot = true;
    }
    var msk = sessionStorage.getItem("mask");
    if (msk.charAt(0)== '1' ) {
       this.isGM = true;
    }

  },
  methods: {
    tologin() {
      this.$router.push({ path: "/" });
    },
    tabfun1001(e, f) {
      this.tabnum = 100 + e;
      this.tabtype = f.type;
      this.tabtype1 = f.type1;
      if (e == 1) {
       // this.$refs.tabnum9.reflash_devlist2();
      }
    },
    tabfun(e, f) {
      this.tabnum = 0;
      this.tabtype = f.type;
      this.tabtype1 = f.type1;
    },
    tabfun1(e, f) {
      this.tabnum = 1;
      this.tabtype = f.type;
      this.tabtype1 = f.type1;
    },
    tabfun2(e, f) {
      this.tabnum = 4;
      this.tabtype = f.type;
      this.tabtype1 = f.type1;
    },
    tabfun3(e, f) {
      this.tabnum = 999;
      this.tabtype = f.type;
      this.tabtype1 = f.type1;
    },
    tabfun4(e, f) {
      this.tabnum = 500 + e;
      this.tabtype = f.type;
      this.tabtype1 = f.type1;
    },
    tabfun100(e, f) {
      this.tabnum = 200 + e;
      this.tabtype = f.type;
      this.tabtype1 = f.type1;
    },
    tabfun101(e, f) {
      this.tabnum = 300 + e;
      this.tabtype = f.type;
      this.tabtype1 = f.type1;
    },
    tabfun6(e, f) {
      this.tabnum = 600 + e;
      this.tabtype = f.type;
      this.tabtype1 = f.type1;
      if (e == 0) {
        this.$refs.tabnum3.reflash_devlist();
      }
	  if (e == 1) {
	    this.$refs.tabnum15.reflash_devlist();
	  }
    },
    tabfun7(e, f) {
      this.tabnum = 700 + e;
      this.tabtype = f.type;
      this.tabtype1 = f.type1;
      if (e == 0) {
        this.$refs.tabnum4.get_file_list();
      } else if (e == 1) {
        this.$refs.tabnum12.get_file_list();
      }
    }
  },
  components: {
    HeaderBar,
    Tabnum3,
    Tabnum4,
    Tabnum5,
    Tabnum6,
    Tabnum7,
    Tabnum8,
    Tabnum9,
    Tabnum10,
    Tabnum11,
    Tabnum12,
    Tabnum13,
    Tabnum14,
    Tabnum15,
    Tabnum16
  },
  computed: {
    usertype() {
      return sessionStorage.getItem("UserType");
    }
  }
};
</script>


<style   scoped>
.index {
  height: 100%;
  display: flex;
}
.leftbar {
  flex: 0 0 235px;
  width: 235px;
  height: 100%;
  background: #001529;
  min-height: 98vh;
}
.coxiaom{
	background-color: #ff0000;
}
.rightbar {
  flex: auto;
  background: #f0f2f5;
}
.homename {
  height: 64px;
  background: #002140;
  line-height: 64px;
  font-size: 20px;
  font-weight: bold;
  color: #fff;
}
.bar {
  color: #fff;
  background: #042442;
  cursor: pointer;
  height: 50px;
  line-height: 50px;
  text-align: left;
  text-indent: 50px;
}
.bar:hover {
  background: #0f3961;
}
.active {
  background: #0f3961;
}
.righthead {
  height: 64px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  position: relative;
  z-index: 1;
}

.userinfo {
  width: 120px;
  float: right;
  margin-right: 10px;
  height: 64px;
  line-height: 64px;
  cursor: pointer;
}
.userinfo:hover {
  background: #e6f7ff;
}
.tab {
  height: 50px;
  border-bottom: #e8e8e8;
  text-align: left;
  background: #fff;
  line-height: 50px;
  font-size: 15px;
  text-indent: 30px;
  color: #999;
}
.tab em {
  color: #42b983;
}
.el-collapse {
  text-indent: 20px;
}

</style>



// WEBPACK FOOTER //
// src/xxxvue/mg.vue